'use strict';

angular.module('amexReconciliationApp')
  .component('cycleReceiptTile', {
    bindings: {
      receipt: '<',
      onDelete: '&'
    },
    templateUrl: 'scripts/views/components/cycle-receipt-tile.html',
    controller: function (ReceiptService,
                          ReceiptRepository,
                          TransactionSearchModel,
                          SiteConfigModel) {
      var self = this;

      self.isReceiptViewable = ReceiptService.isReceiptViewable;

      self.setEditDetailsFlag = function() {
          self.editReceiptDetailsFlag = true;
      };

      self.unsetEditDetailsFlag = function() {
          self.editReceiptDetailsFlag = false;
      };

      self.editDetails = function() {
          return self.editReceiptDetailsFlag;
      };

      self.togglePopover = function() {
        self.toggle = !self.toggle;
      };

      self.deleteReceipt = function deleteReceipt() {
        ReceiptRepository.deleteReceipt(self.receipt)
          .then(function(receipt) {
            return self.onDelete({receipt: receipt});
          })
          .then(function () {
            self.toggle = false;
          });
      };

      self.showDelete = function () {
        return (
          !self.receipt.matched &&
          !ReceiptService.receiptUploadingIsLocked() &&
          !TransactionSearchModel.isBcaManager() &&
          !TransactionSearchModel.isLimitedRole() &&
          SiteConfigModel.deleteReceiptEnabledForRole(TransactionSearchModel.roleName())
        );
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/cycleReceiptTile.js
// module id = 444
// module chunks = 0